import PopOutIcon from "../icons/cisco-momentum/core/pop-out-regular.svg?react"
import PeopleIcon from "../icons/cisco-momentum/core/people-regular.svg?react"
import ShieldIcon from "../icons/cisco-momentum/core/shield-regular.svg?react"
import AdminIcon from "../icons/cisco-momentum/core/admin-regular.svg?react"
import SettingsIcon from "../icons/cisco-momentum/core/settings-regular.svg?react"
import FlagIcon from "../icons/cisco-momentum/core/flag-regular.svg?react"
import DeviceInRoomIcon from "../icons/cisco-momentum/core/device-in-room-regular.svg?react"
import RoomCalendarIcon from "../icons/cisco-momentum/core/room-calendar-regular.svg?react"
import CalendarIcon from "../icons/cisco-momentum/core/calendar-month-regular.svg?react"
import IntegrationsIcon from "../icons/cisco-momentum/core/integrations-regular.svg?react"
import AppsIcon from "../icons/cisco-momentum/core/apps-regular.svg?react"
import RefreshIcon from "../icons/cisco-momentum/core/refresh-regular.svg?react"
import BellIcon from "../icons/cisco-momentum/core/alert-regular.svg?react"
import AreaChartIcon from "../icons/cisco-momentum/core/area-chart-regular.svg?react"
import HelpIcon from "../icons/cisco-momentum/core/ask-for-help-regular.svg?react"
import DocumentIcon from "../icons/cisco-momentum/core/document-regular.svg?react"
import CertificateIcon from "../icons/cisco-momentum/core/certificate-regular.svg?react"

/**
 * Sidebar menu configuration with permission keys.
 *
 * Each item's permissionKey maps to sidebar_permissions.items[key] from the backend.
 * The backend SidebarPermissions service checks Pundit policies to determine visibility.
 *
 * Properties:
 *   name:          Display name shown in sidebar
 *   href:          URL path (prefixed with /{org_id} when orgScoped is true)
 *   icon:          Icon component to render
 *   orgScoped:     When true, href is prefixed with organization ID
 *   permissionKey: Key matching SidebarPermissions::SIDEBAR_ITEMS
 *   external:      Opens in new tab, no permission check needed
 */
export const menuSections = [
  {
    id: "main",
    items: [
      {
        name: "Video Spaces",
        href: "/video_spaces",
        icon: DeviceInRoomIcon,
        orgScoped: true,
        permissionKey: "video_spaces"
      },
      {
        name: "Scheduled Spaces",
        href: "/scheduled_spaces",
        icon: RoomCalendarIcon,
        orgScoped: true,
        permissionKey: "scheduled_spaces"
      },
      {
        name: "Scheduled Events",
        href: "/scheduled_events",
        icon: CalendarIcon,
        orgScoped: true,
        permissionKey: "scheduled_events"
      },
    ]
  },
  {
    id: "management",
    title: "MANAGEMENT",
    items: [
      {
        name: "Members",
        href: "/memberships",
        icon: PeopleIcon,
        orgScoped: true,
        permissionKey: "members"
      },
      // {
      //   name: "Security Groups",
      //   href: "/security_groups",
      //   icon: ShieldIcon,
      //   orgScoped: true,
      //   permissionKey: "security_groups"
      // },
      {
        name: "Linked Accounts",
        href: "/linked_accounts",
        icon: IntegrationsIcon,
        orgScoped: true,
        permissionKey: "linked_accounts"
      },
      {
        name: "LTI Registrations",
        href: "/lti_registrations",
        icon: AppsIcon,
        orgScoped: true,
        permissionKey: "lti_registrations"
      },
      // {
      //   name: "API Keys",
      //   href: "/api_keys",
      //   icon: AdminIcon,
      //   orgScoped: true,
      //   permissionKey: "api_keys"
      // },
      {
        name: "Sync Workers",
        href: "/monitored_workers",
        icon: RefreshIcon,
        orgScoped: true,
        permissionKey: "sync_workers"
      },
      {
        name: "Sync Notifications",
        href: "/sync_alert_notifications",
        icon: BellIcon,
        orgScoped: true,
        permissionKey: "sync_notifications"
      }
    ]
  },
  {
    id: "admin",
    title: "PLATFORM ADMIN",
    items: [
      {
        name: "Analytics",
        href: "/analytics",
        icon: AreaChartIcon,
        orgScoped: true,
        permissionKey: "analytics"
      },
      {
        name: "Settings",
        href: "/application_settings",
        icon: SettingsIcon,
        orgScoped: true,
        permissionKey: "settings"
      },
      {
        name: "Feature Flags",
        href: "/feature_flags",
        icon: FlagIcon,
        orgScoped: true,
        permissionKey: "feature_flags"
      },
      {
        name: "Webex Service Admin",
        href: "/webex_service_admin",
        icon: CertificateIcon,
        orgScoped: false,
        permissionKey: "webex_service_admin"
      },
      {
        name: "Audit Logs",
        href: "/audit_logs",
        icon: DocumentIcon,
        orgScoped: true,
        permissionKey: "audit_logs"
      }
    ]
  },
  {
    id: "help",
    title: "HELP",
    items: [
      {
        name: "Documentation",
        href: "/docs/",
        icon: HelpIcon,
        external: true
      }
    ]
  }
]

// Re-export PopOutIcon for use in Sidebar
export { PopOutIcon }
